import type { KeyboardEvent } from 'react';
import type React from 'react';
import { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useInvoice } from '../hooks/useInvoice';
import { AdornedInput, Form, Spinner } from '@zillow/constellation-10';
import { IconCloseCircleFilled, IconSearchOutline } from '@zillow/constellation-icons';
import { emitSearchByInvoiceNumberEvent, EVENT_IDS } from '../model/ClickstreamEvents';
import { LoadingConstants, useRentalManagerUser } from '@zg-rentals/rental-manager-env';

const InvoiceSearchBox = () => {
  const { invoice, loadingState, fetchInvoice } = useInvoice();
  const [searchText, setSearchText] = useState('');
  const { user } = useRentalManagerUser();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const clearSearchText = () => {
    setSearchText('');
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    fetchInvoice(searchText);
    emitSearchByInvoiceNumberEvent({ user });
  };

  const renderSpinnerOrClear = () =>
    searchText ? <IconCloseCircleFilled onClick={clearSearchText} /> : <IconSearchOutline />;

  const handleKeyUp = (e: KeyboardEvent) => {
    if (e.key === 'Escape') clearSearchText();
  };

  if (invoice) {
    return <Redirect to={`/rental-manager/billing/invoice/${invoice.invoiceNumber}`} />;
  }

  return (
    <Form onSubmit={handleSubmit} data-eventid={EVENT_IDS.SEARCH_BY_INVOICE_NUMBER} css={{ position: 'relative' }}>
      <AdornedInput
        data-test="SearchBox-Component"
        input={
          <AdornedInput.Input
            placeholder="Search by Invoice No"
            onChange={handleChange}
            onKeyUp={handleKeyUp}
            value={searchText}
          />
        }
        endAdornment={
          <AdornedInput.Adornment>
            <AdornedInput.Icon size="sm">
              {loadingState === LoadingConstants.LOADING ? <Spinner /> : renderSpinnerOrClear()}
            </AdornedInput.Icon>
          </AdornedInput.Adornment>
        }
      />
    </Form>
  );
};

export default InvoiceSearchBox;
